import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=7a125bdf&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=7a125bdf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a125bdf",
  null
  
)

export default component.exports